<template>
  <div>
    <my-asidebar v-bind:active-tab="'reports'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <iframe
          v-if="dashboardUrl"
          :src="dashboardUrl"
          frameborder="0"
          width="1400"
          height="1200"
          allowtransparency
      ></iframe>
      <h5 v-else> Raporlama sistemi güncelleniyor lütfen 1 dakika sonra tekrar deneyiniz.</h5>
    </section>

  </div>
</template>

<script>
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";


export default {
  name: "DashboardAppPage",
  components: {MyAsidebar,  TopBar},
  data:function (){
    return{
      dashboardUrl:""
    }
  },
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
    // dashboardUrl:{
    //   get(){
    //     return window.dashboardUrl;
    //   }
    // },
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_DASHBOARD_APP"]) this.$router.push("/");

    this.$store.dispatch("loadMetabaseDashboardUrl", this.$route.params.id)
    .then(response => {
      this.dashboardUrl = response.dashboardUrl;
      if(!this.dashboardUrl){
        setTimeout(()=>{
          window.location.reload();
        },30000)
      }
    })
  }
}
</script>

<style scoped>

</style>